import React from 'react';
import './comp_popup_contact.css';
let _isOpenBox=false;
export function OpenChatPop(){
    //alert("i am in click open");
    if(_isOpenBox===false){
        document.getElementById("myFormChatPop").style.display = "block";
        document.getElementById("close-icon").style.display="block";
        document.getElementById("open-icon").style.display="none";
        _isOpenBox=true;
    }else{
        document.getElementById("myFormChatPop").style.display = "none";
        document.getElementById("close-icon").style.display="none";
        document.getElementById("open-icon").style.display="block";
        _isOpenBox=false;
    }
    
}
export function CloseChatPop(){
    
}
export const Comp_Popup_Contact=(props)=>{
    return(<div class="chatbox1">
        {/* <h2>Popup Chat Window</h2> */}
        <button class="open-button" onClick={()=>OpenChatPop()}>
            <i id="open-icon" class="fa fa-comments-o fa-2x" aria-hidden="true"></i>
            <i id="close-icon" class="fa fa-times fa-2x close-icon" aria-hidden="true"></i>
            </button>
        
        <div class="chat-popup" id="myFormChatPop" name="myFormChatPop">
          <form class="chat-container">
            {/* <h2 class="center">Get in Touch</h2> */}
            <a href="https://wa.me/919958515785" class="chat-btn flex-item mb-2 "><i class="fa fa-whatsapp fa-2x" aria-hidden="true"></i></a>
            <a target="blank" href="tel:+919958515785" class="chat-btn flex-item mb-2 "><i class="fa fa-phone fa-2x" aria-hidden="true"></i></a>
           
          </form>
        </div></div>);
}
export default Comp_Popup_Contact;